import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@cargomatic/ui';
import LaneRateAudits from './LaneRateAudits';

export function LaneRateAuditTrailModal({ show, rate, onHide, type }) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={show}
      onOpenChange={(open) => {
        if (!open) onHide();
      }}
    >
      <DialogContent className="sm:max-w-[90vw] max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t('AUDIT_TRAIL')}</DialogTitle>
        </DialogHeader>
        <div className="flex-auto">
          <LaneRateAudits rate={rate} type={type} />
        </div>
        <DialogFooter>
          <Button onClick={onHide}>{t('CLOSE').toUpperCase()}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
